
import { Vue, Component } from 'nuxt-property-decorator';
import averyTemplates from '@/core/averyTemplates';

@Component({})
export default class TagsLayout extends Vue {
  readonly averyTemplates = averyTemplates;
}
